import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./navBar.css";

type Props = {
  activeSection?: string;
};

const Menu = ({ activeSection = "inicio" }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const linksRef = useRef<HTMLDivElement | null>(null);
  const indicatorRef = useRef<HTMLSpanElement | null>(null);

  const closeMenu = () => setIsOpen(false);
  const toggleMenu = () => setIsOpen((v) => !v);

  const toHash = (id: string) => `/#${id}`;

  // Mover nav-indicator al link activo (desktop) v
  useEffect(() => {
    const container = linksRef.current;
    const indicator = indicatorRef.current;
    if (!container || !indicator) return;

    const activeLink = container.querySelector<HTMLAnchorElement>(
      `a[data-section="${activeSection}"]`
    );

    if (!activeLink) {
      indicator.style.opacity = "0";
      return;
    }

    const linkRect = activeLink.getBoundingClientRect();
    const contRect = container.getBoundingClientRect();

    const paddingFix = 10;
    const width = Math.max(0, linkRect.width - paddingFix * 2);
    const x = Math.max(0, linkRect.left - contRect.left + paddingFix);

    indicator.style.width = `${width}px`;
    indicator.style.transform = `translateX(${x}px)`;
    indicator.style.opacity = "1";
  }, [activeSection]);

  // Recalcular indicador al resize
  useEffect(() => {
    const onResize = () => {
      const container = linksRef.current;
      const indicator = indicatorRef.current;
      if (!container || !indicator) return;

      const activeLink = container.querySelector<HTMLAnchorElement>(
        `a[data-section="${activeSection}"]`
      );
      if (!activeLink) return;

      const linkRect = activeLink.getBoundingClientRect();
      const contRect = container.getBoundingClientRect();

      const paddingFix = 10;
      const width = Math.max(0, linkRect.width - paddingFix * 2);
      const x = Math.max(0, linkRect.left - contRect.left + paddingFix);

      indicator.style.width = `${width}px`;
      indicator.style.transform = `translateX(${x}px)`;
      indicator.style.opacity = "1";
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [activeSection]);

  return (
    <header className={`navbar ${isOpen ? "is-open" : ""}`}>
      <div className="navbar-container">
        <Link to={toHash("inicio")} className="navbar-logo" onClick={closeMenu}>
          {/* deja tu logo tal cual */}
        </Link>

        <button
          type="button"
          className="navbar-toggle"
          aria-label="Abrir menú"
          aria-expanded={isOpen}
          onClick={toggleMenu}
        >
          <span className="navbar-toggle-icon" />
        </button>

        <nav className="navbar-links" ref={linksRef}>
          <Link
            to={toHash("inicio")}
            data-section="inicio"
            className={`navbar-link ${activeSection === "inicio" ? "active" : ""}`}
            onClick={closeMenu}
          >
            Inicio
          </Link>

          <Link
            to={toHash("servicios")}
            data-section="servicios"
            className={`navbar-link ${activeSection === "servicios" ? "active" : ""}`}
            onClick={closeMenu}
          >
            Servicios
          </Link>

          <Link
            to={toHash("clientes")}
            data-section="clientes"
            className={`navbar-link ${activeSection === "clientes" ? "active" : ""}`}
            onClick={closeMenu}
          >
            Clientes
          </Link>

          <Link
            to={toHash("proyectos")}
            data-section="proyectos"
            className={`navbar-link ${activeSection === "proyectos" ? "active" : ""}`}
            onClick={closeMenu}
          >
            Proyectos
          </Link>

          <Link
            to={toHash("contacto")}
            data-section="contacto"
            className={`navbar-link ${activeSection === "contacto" ? "active" : ""}`}
            onClick={closeMenu}
          >
            Contacto
          </Link>

          <span className="nav-indicator" ref={indicatorRef} />
        </nav>
      </div>
    </header>
  );
};

export default Menu;